import React from "react";
import { pushDatatoAdobeLayer } from "../../analytics/pmiAdobeLog";
import { getAdobeAnalyticsEventObject, getAdobeAnalyticsCustomLinkObj, getAdobeAnalyticsPlayListObj } from '../../analytics/analyticsObject';
const DeletePlaylistModal = ({ itemType, closeModal, deleteItem, playlist }) => {
  const deleteItems = () => {
    deleteItem();
    closeModal();
  };

  return (
    <div className="fixed inset-0 z-50 overflow-auto flex" onClick={closeModal}>
      <div className="relative p-6 rounded border border-2 border-blue-600 shadow-lg bg-white max-w-xs m-auto flex-col flex">
        <button
          onClick={closeModal}
          className="w-3 self-end cursor-pointer hover:text-red-600"
        >
          X
        </button>
        <div className="mt-4">
          {itemType === "playlist" && (
            <div className="mb-4 text-center">
              <h1 className="title-font-28 mb-4">Delete Playlist</h1>
              <p className="mb-2">Do you want to delete this playlist?</p>
              <p>Your items will be deleted as well</p>
            </div>
          )}

          {itemType === "item" && (
            <div className="mb-4 text-center">
              <h1 className="title-font-28 mb-4">Delete Content Item</h1>
              <p>Do you want to delete this content item from the playlist?</p>
            </div>
          )}

          {itemType === "allItems" && (
            <div className="mb-4 text-center">
              <h1 className="title-font-28 mb-4">Delete All Items</h1>
              <p>Do you want to delete all items from this playlist?</p>
            </div>
          )}

          <div className="flex flex-wrap justify-around">
            <button
              className="p-3 rounded border border-red-800 bg-white text-red hover:bg-red-800 hover:text-white shadow font-bold"
              onClick={deleteItems}
            >
              Delete
            </button>
            <button
              className="p-3 rounded border border-blue-800 bg-white text-blue hover:bg-blue-800 hover:text-white shadow font-bold"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeletePlaylistModal;
